export const UPDATE_EDOK_DOCUMENTATIONS_SUCCESS = 'UPDATE_EDOK_DOCUMENTATIONS_SUCCESS';

export const updateEdokDocumentationsSuccess = (documentations) => ({
    type: UPDATE_EDOK_DOCUMENTATIONS_SUCCESS,
    payload: {
        documentations,
    },
});
